<template>
  <div class="position-relative w-100 h-100">
    <ForgetPasswordPage
      v-if="stepIndexActive == stepActive.REQUEST"
      :formData="formData"
      :errorMessage="errorMessage"
      @onNextStep="onSubmit"
    />
    <ForgetPasswordSuccessPage
      v-if="stepIndexActive == stepActive.SUCCESS"
      :formData="formData"
      @onGoTo="goTo"
    />
  </div>
</template>

<script>
import {
  getCurrentInstance,
  reactive,
  computed,
  onBeforeMount,
  ref,
} from "@vue/composition-api";
import store from "@/store/index";
import router from "@/router";

import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import ForgetPasswordPage from "@/views/pages/authentication/login/components/ForgetPassword.vue";
import ForgetPasswordSuccessPage from "@/views/pages/authentication/login/components/ForgetPasswordSuccess.vue";
import forgetPasswordModel from "@/models/forget-password/forget-password";
export default {
  directives: {
    Ripple,
  },
  props: { brandRef: { type: String, default: null } },
  components: {
    ForgetPasswordPage,
    ForgetPasswordSuccessPage,
  },

  setup(props, { emit }) {
    const {
      openErrorModal,
      openDefaultErrorModal,
      openSuccessModal,
    } = useValidationModal();

    const { decodeParamToken } = useDecodeToken();

    const { forgetPassword, passwordRecovery } = forgetPasswordModel();
    const formData = reactive({ brandRef: null, email: null });
    const errorMessage = ref(null);

    const stepActive = reactive({
      REQUEST: 0,
      SUCCESS: 1,
    });

    const stepIndexActive = ref(0);

    let decodeToken = null;

    const onSubmit = (email) => {
      errorMessage.value = null;
      nextStep(email).then((resp) => {
        if (resp.isSuccess) stepIndexActive.value += 1;
        else {
          if (resp.data.status == 404) {
            errorMessage.value = "ไม่พบอีเมลนี้ในระบบ กรุณาตรวจสอบอีกครั้ง";
          } else {
            openErrorModal(
              resp.data.data.error.locale["th-th"].title,
              resp.data.data.error.locale["th-th"].message
            );
          }
        }
      });
    };

    const nextStep = (email) => {
      return new Promise((resolve, reject) => {
        if (!email) return;
        window.$loading(true);

        formData.email = email;
        forgetPassword.payload.brand_ref = formData.brandRef;
        forgetPassword.payload.email = formData.email;

        store
          .dispatch("api/apiRequest", forgetPassword)
          .then((response) => {
            resolve({ isSuccess: true, data: response });
          })
          .catch((error) => {
            resolve({ isSuccess: false, data: error });
          })
          .finally(() => {
            window.$loading(false);
          });
      });
    };

    const reloadPage = () => {
      document.location.reload();
    };

    const goTo = () => {
      //to Url
      router
        .replace({ path: "/login", query: { brandRef: formData.brandRef } })
        .catch(() => {});

      setTimeout(() => {
        reloadPage();
      }, 100);
    };

    onBeforeMount(() => {
      if (props.brandRef) {
        formData.brandRef = props.brandRef;
      } else if (decodeParamToken()) {
        decodeToken = decodeParamToken();
        if ("brand_ref" in decodeToken)
          formData.brandRef = decodeToken.brand_ref;
      }
    });

    return {
      stepIndexActive,
      stepActive,
      formData,
      errorMessage,
      nextStep,
      goTo,
      onSubmit,
    };
  },
};
</script>
